import {Component} from '@angular/core';

@Component({
    selector: 'app-news-events',

    templateUrl: './news-events.component.html',
    styleUrl: './news-events.component.css'
})
export class NewsEventsComponent {


}
